document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(e){
  const toggle=e.target.closest('[data-mobile-toggle]');
  if(toggle){const nav=document.querySelector('[data-mobile-nav]'); if(nav) nav.hidden=!nav.hidden;}
});
document.addEventListener('change', function(e){
  if(e.target.matches('[data-variant-select]')){
    const option=e.target.options[e.target.selectedIndex];
    const price=document.querySelector('[data-product-price]');
    const id=document.querySelector('[name="id"]');
    if(price && option.dataset.price) price.textContent=option.dataset.price;
    if(id) id.value=e.target.value;
  }
});
